<template>
  <LayoutPopup id="Cai-dat-hien-thi" size="small">
    <template #title>Cài đặt hiển thị</template>

    <template #content>
      <draggable v-model="listField">
        <div
          class="__row"
          v-for="(element) in listField" 
          :key="element.id"
        >
          <div class="__row_container" v-if="!['edit', 'selected'].includes(element.key)">
            <BaseCheckbox v-model="element.show" :disabled="element.disabled"/>
            <p class="__row_name">{{element.label}}</p>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.5 12.5H5.5C5.21875 12.5 5 12.75 5 13V13.5C5 13.7812 5.21875 14 5.5 14H18.5C18.75 14 19 13.7812 19 13.5V13C19 12.75 18.75 12.5 18.5 12.5ZM18.5 9H5.5C5.21875 9 5 9.25 5 9.5V10C5 10.2812 5.21875 10.5 5.5 10.5H18.5C18.75 10.5 19 10.2812 19 10V9.5C19 9.25 18.75 9 18.5 9Z"
                fill="#74788D"
              />
            </svg>
          </div>
        </div>
      </draggable>
    </template>

    <template #control-right>
      <BaseButton
        size="sm"
        variant="secondary"
        @click="closePopup"
      >
        Thoát
      </BaseButton>
      <BaseButton 
        size="sm" 
        @click="submit"
      >
        Hoàn tất
      </BaseButton>
    </template>
  </LayoutPopup>
</template>

<script>
export default {
  props:{
    list: {
      type: Array,
      default: () => []
    }
  },

  model:{
    prop: "list",
    event: "value"
  },

  data() {
    return {
      listField: [],
      listFieldTmp: [],
      fieldEdit: ''
    }
  },

  methods: {
    closePopup() {
      this.hidePopup('Cai-dat-hien-thi')
      this.listField = this.listFieldTmp.map(e => e)
    },

    submit() {
      this.hidePopup('Cai-dat-hien-thi')
      this.$emit('value', this.listField)
    }
  },

  created() {
    const listTmp = this.list.map((e, index) => {
      return {
        ...e,
        id: index
      }
    })
    this.listFieldTmp = listTmp
    this.listField = listTmp
  },

  watch: {
    list: function () {
      const listTmp = this.list.map((e, index) => {
        return {
          ...e,
          id: index,
          disabled: (e.disabled) ? e.disabled : false 
        }
      })
      this.listFieldTmp = listTmp
      this.listField = listTmp
    },
    deep: true
  }
};
</script>

<style lang="scss" scoped>
.__row {
  border-bottom: 1px solid #d2d2d3;

  &_container {
    padding: 12px 9px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  &:last-child {
    border: none
  }

  &_name {
    flex: 1;
    margin: 0px;
  }
}
</style>